import React, { ReactNode } from 'react';
import { Button, Stack } from '@moda/om';
import classNames from 'classnames';
import { ADD_TO_BAG_FRAGMENT, useAddToBag, UseAddToBagProps } from '../../hooks/useAddToBag';

import './AddToBagButton.scss';

export { ADD_TO_BAG_FRAGMENT };

export type AddToBagButtonProps = UseAddToBagProps & {
  className?: string;
  children?: ReactNode;
};

export const AddToBagButton: React.FC<AddToBagButtonProps> = ({ className, children, ...rest }) => {
  const { disabled, error, handleAddToBag, text } = useAddToBag(rest);

  return (
    <Button
      className={classNames('AddToBagButton', className)}
      aria-label={text}
      disabled={disabled}
      secondary={error}
      onClick={handleAddToBag}
    >
      <Stack space={0} direction="vertical">
        <div className="AddToBagButton__text">{text}</div>
        {children}
      </Stack>
    </Button>
  );
};
